/**
 * @module builder
 */
import type { MoveableItem } from '../../index'

export function moveToBid(item: MoveableItem): any {
  return {
    ...item,
    show: true,
    use_total: true,
    additionalWork: false,
    pending: false
  }
}
